<template>
  <div>
    <div class="owner_title">稿费预支申请记录</div>
    <!-- 筛选 -->
    <div class="task_filtrate" @click="show_filter_form()">
      <i class="iconfont icon-shaixuan1"></i>
      <span>筛选</span>
    </div>

    <!-- 筛选表单 -->
    <div class="task_filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="申请写手" prop="writer_nickname">
          <el-input v-model="filter_form.writer_nickname"></el-input>
        </el-form-item>
        <el-form-item label="审核人" prop="username">
          <el-input v-model="filter_form.username"></el-input>
        </el-form-item>
        <el-form-item label="预支金额" prop="money">
          <el-input v-model="filter_form.money"></el-input>
        </el-form-item>
        <el-form-item label="书名" prop="connectionessay_name">
          <el-input v-model="filter_form.connectionessay_name"></el-input>
        </el-form-item>
        <el-form-item label="是否通过">
          <el-select v-model="filter_form.status" placeholder="是否通过">
            <el-option label="全部" value=""></el-option>
            <el-option label="审查中" value="0"></el-option>
            <el-option label="通过" value="1"></el-option>
            <el-option label="驳回" value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="驳回原因" prop="reason">
          <el-input v-model="filter_form.reason"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="filter_form.remark"></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="filter_form.createtime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="goSearch"
          >搜索</el-button
        >
      </el-form>
    </div>

    <div class="seas_box">
      <!-- 表格数据    -->
      <el-table height="550" :data="dataShow" border style="width: 100%">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="writer_nickname"
          label="申请写手"
          width="200"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="username"
          label="审核人"
          align="center"
          width="120"
          sortable
        >
        </el-table-column>

        <el-table-column
          property="money"
          label="预支金额"
          width="120"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="connectionessay_name"
          label="书名"
          width="250"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="status"
          label="是否通过"
          width="120"
          align="center"
          sortable
        >
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.status == '0'
                  ? ''
                  : scope.row.status == '1'
                  ? 'success'
                  : 'danger'
              "
            >
              {{
                scope.row.status == "0"
                  ? "审查中"
                  : scope.row.status == "1"
                  ? "通过"
                  : "驳回"
              }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          property="createtime"
          label="创建时间"
          width="180"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="reason"
          label="驳回原因"
          width="200"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column property="remark" label="备注" align="center" sortable>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { advancefee_apply } from "@/utils/writer";
export default {
  data() {
    return {
      writerId: "", //所属写手部id
      advanceList: [], //预支稿费列表
      isFilterForm: true, //筛选表单
      dataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      // 筛选
      filter_form: {
        writer_nickname: "", //申请写手
        username: "", //审核人
        money: "", //预支金额
        connectionessay_name: "", //是否通过
        createtime: "", //创建时间1
        reason: "", //驳回原因
        remark: "" //备注
      },
      select_time_data: "",
      time_filter: "" //时间筛选
    };
  },
  created() {
    this.writerId = JSON.parse(localStorage.getItem("userInfo")).id;
    this.getAdvanceList();
  },
  methods: {
    // 获取接单中心列表
    getAdvanceList() {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId
      };
      advancefee_apply(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.advanceList = res.data.data;
          that.calcPageData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // 筛选
    goSearch() {
      var that = this;
      var date1, date2;
      that.select_time_data = that.filter_form.createtime;
      date1 = that.select_time_data[0];
      date2 = that.select_time_data[1];
      if (date1 == undefined && date2 == undefined) {
        that.time_filter = "";
      } else {
        that.time_filter = date1 + " - " + date2;
      }
      console.log("that.time_filter", that.time_filter);
      that.filter_form.createtime = that.time_filter;
      let obj = {
        departmentuser_id: that.writerId,
        ...that.filter_form
      };
      advancefee_apply(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.advanceList = res.data.data;
          that.calcPageData();
          that.filter_form.createtime = that.select_time_data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    // 计算页数的方法
    calcPageData() {
      if (this.advanceList.length > 1) {
        this.pageNum = Math.ceil(this.advanceList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.advanceList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }
      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.dataShow = this.totalPageData[val - 1];
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}
.seas_box {
  margin: 0px 15px;
}
.task_btn {
  /* width: 90px;
  height: 25px;
  text-align: center;
  line-height: 5px; */
  background: #f3f8ff;
  color: #157df8;
}
.mywriter_btn {
  width: 110px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #157df8;
  border-radius: 10px;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
}
.mywriter_btn i {
  font-size: 12px;
}
.info_icon {
  font-size: 12px;
}
.task_filtrate {
  text-align: right;
  padding: 10px 15px 10px 15px;
}
.task_filtrate i {
  font-size: 14px;
}
.task_filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.task_filter_form {
  background: #ffffff;
  margin: 0px 15px;
  padding-top: 15px;
}
.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.sea_box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.remark_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  border-radius: 10px;
  margin-left: 5px;
}
.remark_btn i {
  font-size: 12px;
}

.seas_box .el-tag {
  width: 90px;
  margin: 5px auto;
}
.el-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 20px;
  border-radius: 10px;
  margin-left: 15px;
}
.file_box {
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .seas_box {
    margin-bottom: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/writer/ManuscriptAdvance.vue